import { render } from "./App.vue?vue&type=template&id=c5b1794a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c5b1794a&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b1794a"],['__file',"src/assets/js/components/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5b1794a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5b1794a', __exports__)) {
    api.reload('c5b1794a', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=c5b1794a&scoped=true", () => {
    api.rerender('c5b1794a', render)
  })

}


export default __exports__